// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__lSH4w","policiesContainer":"Footer_policiesContainer__OQCY2","divider":"Footer_divider__B2mOv"};